import { Location } from '../../location';
import { getPageMetaData } from '../../utils/get-page-meta-data';
import { hasInventoryData } from '../../utils/helpers';

export class ListingLocation extends Location {
	constructor(name) {
		super(name);
		this.name = name;
	}

	isReady() {
		return hasInventoryData();
	}

	async getConfig() {
		return {
			singleLocation: true
		};
	}

	getMeta() {
		return getPageMetaData();
	}
}
